import Vue from 'vue';
import store from '@/store';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import i18n from '@/i18n';

export const aodaService = {
  async downloadUserGuide(userGuide) {
    let response;
    try {
      response = await Vue.axios({
        url: `/aoda/${userGuide}/download`,
        method: 'GET',
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${userGuide}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (e) {
      const status = e.status;
      let message;
      switch (status) {
        case 403:
          message = i18n.t('attachments.errors.forbiddenView');
          break;
        case 404:
          message = i18n.t('attachments.errors.notFound');
          break;
        default:
          message = i18n.t('attachments.errors.unknown', { status });
      }

      store.dispatch(TolErrorsActions.SetError, { message });
    }
  },

  async submitAodaForm(aodaForm) {
    return Vue.axios
      .post('/aoda/aoda-form', {
        ...aodaForm
      })
      .then(({ data }) => Promise.resolve(data));
  }
};
